import React from 'react'
import PropTypes from 'prop-types'
import { HStack, Text, VStack } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function RefillsIndicator({ icon, label, subLabel, color, iconColor }) {
  return (
    <HStack
      ml={4}
      spacing="16px"
      justifyContent="start"
      alignItems="center"
      h="100%"
      w="100%"
    >
      <FontAwesomeIcon
        color={iconColor || color || null}
        size="lg"
        icon={icon}
      />
      <VStack alignItems="flex-start">
        <Text color={color || null} variant="regular">
          {label}
        </Text>
        <Text color={color || null} variant="semibold">
          {subLabel}
        </Text>
      </VStack>
    </HStack>
  )
}

RefillsIndicator.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.any,
  iconColor: PropTypes.any,
  label: PropTypes.string,
  subLabel: PropTypes.string,
}

export default RefillsIndicator
